import api from "../api";

export const chatService = {
  listarConversas() {
    return api.get("/chats/conversas");
  },
  abrirOuCriar(codigoDestinatario) {
    return api.post("/chats/conversas", { codigoDestinatario });
  },
  listarMensagens(codigo, params) {
    return api.get(`/chats/conversas/${codigo}/mensagens`, { params });
  },
  enviar(codigo, conteudo) {
    return api.post(`/chats/conversas/${codigo}/mensagens`, { conteudo });
  },
  marcarComoLida(codigo) {
    return api.put(`/chats/conversas/${codigo}/lida`);
  },
  listarContatos(nome, codigoInstituicao) {
    return api.get("/chats/contatos", {
      params: { nome: nome || "", codigoInstituicao: codigoInstituicao || undefined },
    });
  },
  listarInstituicoes() {
    return api.get("/chats/instituicoes");
  },
  listarFixadas(codigo) {
    return api.get(`/chats/conversas/${codigo}/fixadas`);
  },
  fixarMensagem(codigo, codigoMensagem) {
    return api.put(`/chats/conversas/${codigo}/mensagens/${codigoMensagem}/fixar`);
  },
  desafixarMensagem(codigo, codigoMensagem) {
    return api.put(`/chats/conversas/${codigo}/mensagens/${codigoMensagem}/desafixar`);
  },
  listarLiberacoes() {
    return api.get("/chats/liberacoes");
  },
  listarLiberacoesInstituicao() {
    return api.get("/chats/liberacoes/instituicoes");
  },
  concederLiberacao(codigoUsuarioA, codigoUsuarioB) {
    return api.post("/chats/liberacoes", { codigoUsuarioA, codigoUsuarioB });
  },
  concederLiberacaoInstituicao(codigoInstituicaoA, codigoInstituicaoB) {
    return api.post("/chats/liberacoes/instituicoes", {
      codigoInstituicaoA,
      codigoInstituicaoB,
    });
  },
  concederLiberacaoTodos() {
    return api.post("/chats/liberacoes/todos");
  },
  desativarLiberacao(codigo) {
    return api.put(`/chats/liberacoes/${codigo}/desativar`);
  },
  ativarLiberacao(codigo) {
    return api.put(`/chats/liberacoes/${codigo}/ativar`);
  },
  desativarLiberacaoInstituicao(codigo) {
    return api.put(`/chats/liberacoes/instituicoes/${codigo}/desativar`);
  },
  ativarLiberacaoInstituicao(codigo) {
    return api.put(`/chats/liberacoes/instituicoes/${codigo}/ativar`);
  },
  fixarConversa(codigo) {
    return api.put(`/chats/conversas/${codigo}/fixar`);
  },
  desafixarConversa(codigo) {
    return api.put(`/chats/conversas/${codigo}/desafixar`);
  },
};
